import React, { useState, useEffect } from 'react';
import { BsFillPlayFill } from 'react-icons/bs';
import { Avvia_Partita } from '../../Components';
import Avvia_Partita2 from './Avvia_Partita2';
import Avvia_Partita3 from './Avvia_Partita3';
import Avvia_Partita4 from './Avvia_Partita4';
import logo from '../../assets/Images/logo.png'

const Avvia_Partita1 = (props) => {
    const { setAvvia } = props;
    const [currentScreen, setCurrentScreen] = useState(1);

    const handleSlider = () => {
        if (currentScreen < 4) {
            setCurrentScreen((prevScreen) => prevScreen + 1);
        } else {
            setAvvia(true);
        }
    };

    useEffect(() => {
        let timer;
        if (currentScreen === 2) {
            timer = setTimeout(() => {
                setCurrentScreen(3);
            }, 1000);
        } else if (currentScreen === 3) {
            timer = setTimeout(() => {
                setCurrentScreen(4);
            }, 1000);
        } else if (currentScreen === 4) {
            timer = setTimeout(() => {
                setAvvia(true);
            }, 1000);
        }
        return () => clearTimeout(timer);
    }, [currentScreen, setAvvia]);

   
    return (
        <div>
            {currentScreen === 1 && (

                // <Avvia_Partita
                //     onClick={alert}
                //     icon={<BsFillPlayFill className='Avvia_Partita_center_div_icon'

                //     />}
                //     text='Avvia la partita!'
                //     className='check'

                // />
                <div className='difficolta_container Avvia_Partita_container'>
                    <div className='difficolta_header'>
                        <div className='difficolta_header'>
                            <img src={logo} alt='' className='Avvia_Partita_header_logo' />
                        </div>
                    </div>
                    <div className='Avvia_Partita_center_div' onClick={handleSlider}>
                        <div>
                            <div className='Avvia_Partita_icon_div'>
                                <BsFillPlayFill className='Avvia_Partita_center_div_icon' />

                            </div>
                            <h1 className='Avvia_Partita_center_div_number animate__animated animate__flipInY'></h1>
                        </div>
                    </div>
                    <h1 className='Avvia_Partita_center_text'>Avvia la partita!</h1>
                </div>
            )}
            {currentScreen === 2 && <Avvia_Partita2 />}
            {currentScreen === 3 && <Avvia_Partita3 />}
            {currentScreen === 4 && <Avvia_Partita4 />}
        </div>
    );
};

export default Avvia_Partita1;
